import { render } from "./ConsultationRequestSheet.vue?vue&type=template&id=82faa3ec&scoped=true"
import script from "./ConsultationRequestSheet.vue?vue&type=script&lang=js"
export * from "./ConsultationRequestSheet.vue?vue&type=script&lang=js"

import "./ConsultationRequestSheet.vue?vue&type=style&index=0&id=82faa3ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82faa3ec"]])

export default __exports__